import React from "react";
import { Mail, Shield, LogOut, AtSign, KeyRound, Chrome } from "lucide-react";
import StatusPill from "../../components/primitives/StatusPill";
import TextButton from "../../components/primitives/TextButton";
import "./AccountPage.css";

function Row({ icon: Icon, label, value, mono = false }) {
    return (
        <div className="account-row">
            <span className="account-row__label uppercase-label">
                {Icon && <Icon size={12} aria-hidden="true" />}
                <span>{label}</span>
            </span>
            <span className={`account-row__value ${mono ? "mono" : ""}`}>
                {value || <span className="account-row__empty">—</span>}
            </span>
        </div>
    );
}

function inferMethods(user) {
    if (user?.has_password != null || user?.has_google != null) {
        return {
            google: !!user.has_google,
            password: !!user.has_password,
        };
    }
    // Legacy `/account` shape — only Google profiles return a picture/sub.
    return {
        google: !!(user?.picture || user?.sub),
        password: false,
    };
}

function AccountPage({ user, onSignOut }) {
    const name = user?.name || user?.displayName || "Operator";
    const email = user?.email || "";
    const initial = (name || "?").charAt(0).toUpperCase();
    const methods = inferMethods(user);

    return (
        <div className="account-page">
            <header className="account-page__header">
                <div className="account-page__eyebrow uppercase-label">
                    Console / Account
                </div>
                <h1 className="account-page__title">Operator profile</h1>
                <p className="account-page__subtitle">
                    Identity and session attached to this console.
                </p>
            </header>

            <section className="account-card" aria-labelledby="acct-identity">
                <div className="account-card__head">
                    {user?.picture ? (
                        <img
                            className="account-card__avatar"
                            src={user.picture}
                            alt=""
                            referrerPolicy="no-referrer"
                        />
                    ) : (
                        <div
                            className="account-card__avatar account-card__avatar--fallback"
                            aria-hidden="true"
                        >
                            {initial}
                        </div>
                    )}
                    <div className="account-card__head-text">
                        <h2 id="acct-identity" className="account-card__name">
                            {name}
                        </h2>
                        <div className="account-card__email mono">{email}</div>
                    </div>
                    <StatusPill tone="success">Active</StatusPill>
                </div>

                <div className="account-card__rows">
                    <Row icon={AtSign} label="Display name" value={name} />
                    <Row icon={Mail} label="Email" value={email} mono />
                    <Row
                        icon={Shield}
                        label="Sign-in method"
                        value={
                            <span className="account-methods">
                                {methods.google && (
                                    <span className="account-method">
                                        <Chrome size={11} aria-hidden="true" />
                                        Google
                                    </span>
                                )}
                                {methods.password && (
                                    <span className="account-method">
                                        <KeyRound size={11} aria-hidden="true" />
                                        Password
                                    </span>
                                )}
                                {!methods.google && !methods.password && (
                                    <span className="account-method">
                                        <Mail size={11} aria-hidden="true" />
                                        Magic link
                                    </span>
                                )}
                            </span>
                        }
                    />
                </div>

                <div className="account-card__foot">
                    <TextButton
                        variant="danger"
                        icon={LogOut}
                        onClick={onSignOut}
                    >
                        Sign out
                    </TextButton>
                </div>
            </section>
        </div>
    );
}

export default AccountPage;
